const m2 = {
  "id": "m2",
  "title": "M2",
  "description": {
    "en": "The complex features a richly landscaped inner courtyard. The designated parking spaces are in the basement of the building, which guarantees a peaceful living environment. Thanks to the French windows and the low-rise development in the area, our buildings provide you with a view of Vitosha Mountain. The area has low-rise development up to 10m, new infrastructure. A 10-minute walk to a newly built kindergarten. Close to a future metro station. A 2-minute walk to a public transport stop. The area has large supermarkets - Fantastico, Kaufland and various commercial establishments. With easy and quick access to Ring Mall and Business Park.",
    "bg": "Комплексът разполага с богато озеленен вътрешен двор. Предвидените места за паркиране са в сутерена на сградата, което гарантира спокойна среда на живот. Благодарение на френските прозорци и ниското застрояване в района нашите сгради ви предоставят гледка към планина Витоша. Районът е с ниско етажно застрояване до 10м, нова инфраструктура. На 10 минути пешеходно разстояние до новопостроена детска градина. На близко разстояние от бъдеща метростанция. На 2 минути пешеходно разстояние до спирка на градски транспорт. В района има големи супермаркети – Фантастико, Кауфланд и разнообразни търговски обекти. С лесен и бърз достъп до Ринг мол и Бизнес Парк.",
    "de": "Der Komplex verfügt über einen reichlich begrünten Innenhof. Die vorgesehenen Parkplätze befinden sich im Keller des Gebäudes, was eine ruhige Wohnumgebung garantiert. Dank der französischen Fenster und der niedrigen Bebauung in der Gegend bieten unsere Gebäude einen Blick auf das Vitosha-Gebirge. Das Gebiet hat eine niedrige Bebauung bis zu 10m, neue Infrastruktur. Ein 10-minütiger Spaziergang zu einem neu gebauten Kindergarten. In der Nähe einer zukünftigen U-Bahn-Station. Ein 2-minütiger Spaziergang zu einer Haltestelle des öffentlichen Verkehrs. Das Gebiet hat große Supermärkte - Fantastico, Kaufland und verschiedene Geschäfte. Mit einfachem und schnellem Zugang zum Ring Mall und Business Park.",
    "ru": "Комплекс имеет богато озелененный внутренний двор. Предусмотренные парковочные места находятся в подвале здания, что гарантирует спокойную жилую среду. Благодаря французским окнам и низкой застройке в районе наши здания предоставляют вид на гору Витошу. Район имеет низкую застройку до 10м, новую инфраструктуру. В 10 минутах ходьбы от недавно построенного детского сада. Близко к будущей станции метро. В 2 минутах ходьбы от остановки общественного транспорта. В районе есть крупные супермаркеты - Fantastico, Kaufland и различные коммерческие заведения. С легким и быстрым доступом к Ring Mall и Business Park."
  },
  "location": {
    "en": "Sofia, Simeonovsko shose",
    "bg": "София, Симеоновско шосе",
    "de": "Sofia, Simeonovsko shose",
    "ru": "София, Симеоновско шосе"
  },
  "mapData": {
    "embedUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.1244663146554!2d23.33879831582031!3d42.63735007931567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDM4JzE0LjUiTiAyM8KwMjAnMTkuNyJF!5e0!3m2!1sen!2sbg!4v1733097600000!5m2!1sen!2sbg",
    "directionsUrl": "https://maps.app.goo.gl/fWdKpv1XBRvcor5g7",
    "coordinates": {
      "lat": 42.634642,
      "lng": 23.335937
    }
  },
  "type": "Residential Complex",
  "year": "2024",
  "status": "Act 14",
  "heroImage": "/projects/m2/m2.jpg",
  "images": [
    "/projects/m2/m2.jpg",
    "/projects/m2/m2_1.jpg",
    "/projects/m2/m2_2.jpg",
    "/projects/m2/m2_3.jpg",
    "/projects/m2/m2_4.jpg",
    "/projects/m2/m2_5.jpg",
    "/projects/m2/m2_6.jpg",
    "/projects/m2/m2_7.jpg"
  ],
  "features": {
    "en": [
      "View of Vitosha and the complex garden",
      "Functional layout and spacious rooms",
      "Gated complex with professional property management",
      "Apartments with east, west and south exposure",
      "Choice of parking spaces and garages",
      "Flexible payment scheme",
      "Direct access to Simeonovsko shose",
      "French windows"
    ],
    "bg": [
      "Гледка към Витоша и градината на комплекса",
      "Функционално разпределение и просторни помещения",
      "Затворен комплекс с професионален домоуправител",
      "Апартаменти с източно, западно и южно изложение",
      "Избор на паркоместа и гаражи",
      "Гъвкава схема на плащане",
      "Директен достъп към Симеоновско шосе",
      "Френски прозорци"
    ],
    "de": [
      "Blick auf Vitosha und den Komplexgarten",
      "Funktionale Aufteilung und geräumige Räume",
      "Geschlossener Komplex mit professionellem Hausverwalter",
      "Wohnungen mit östlicher, westlicher und südlicher Ausrichtung",
      "Wahl zwischen Parkplätzen und Garagen",
      "Flexibles Zahlungsschema",
      "Direkter Zugang zur Simeonovsko shose",
      "Französische Fenster"
    ],
    "ru": [
      "Вид на Витошу и сад комплекса",
      "Функциональная планировка и просторные помещения",
      "Закрытый комплекс с профессиональным управляющим",
      "Квартиры с восточной, западной и южной ориентацией",
      "Выбор парковочных мест и гаражей",
      "Гибкая схема оплаты",
      "Прямой доступ к Симеоновскому шоссе",
      "Французские окна"
    ]
  },
  "stats": {
    "area": "2,736 m²",
    "floors": "4",
    "units": "42"
  },
  "availableApartments": 3
};

export default m2;
